import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const isaacConfig: TSPConfig = {
  key: 'isaac',
  name: 'ISAAC',
  category: TSPCategory.CUSTOM,
  helpText: (
    <>
      <p>
        To connect your ISAAC account, you need special API access credentials
        from your ISAAC account manager:
      </p>
      <ol>
        <li>
          Contact your ISAAC account manager and ask them to create API access
          credentials for you
        </li>
        <li>
          They will provide you with three important items:
          <ul>
            <li>
              <strong>API Username</strong> - usually starts with 2 letters
              followed by 3 numbers (followed by a username)
            </li>
            <li>
              <strong>API Password</strong> - a secure password for API access
              only
            </li>
            <li>
              <strong>API Authorization Code</strong> - a special code that
              grants access to your data
            </li>
          </ul>
        </li>
        <li>
          Enter these credentials exactly as provided by your ISAAC
          representative
        </li>
      </ol>
      <p>
        <strong>Important:</strong> These API credentials are different from
        your regular ISAAC login. If you don't have them yet, you'll need to
        contact your ISAAC representative.
      </p>
    </>
  ),
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        {
          label: 'API Username',
          name: 'username',
          type: 'text',
          required: true,
        },
        {
          label: 'API Password',
          name: 'password',
          type: 'password',
          required: true,
        },
        {
          label: 'API Authorization Code',
          name: 'authorizationcode',
          type: 'text',
          required: true,
        },
      ]}
    />
  ),
};

export default isaacConfig;
